<template>
  <div class="loginPage">
    <!-- 背景图层 - bottomBg1 -->
    <div class="bottom-bg-layer"></div>

    <CommonOverlay />

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 大标题 -->
      <div class="big-title">账号绑定</div>

      <!-- UID 输入框 -->
      <div class="uid-wrapper">
        <input
            type="text"
            v-model="uid"
            placeholder="输入你的游戏UID"
            class="uid-input"
        />
      </div>

      <!-- 验证码区域 -->
      <div class="code-row">
        <input
            type="text"
            v-model="code"
            placeholder="请输入验证码"
            class="code-input"
        />
        <button
            class="send-code-btn"
            :disabled="countdown > 0"
            @click="handleSendCode"
        >
          {{ countdown > 0 ? `${countdown}s` : '发送验证码到游戏内邮箱' }}
        </button>
      </div>

      <!-- 登录按钮 -->
      <div class="login-btn" @click="handleLogin">登录</div>

      <!-- 说明文本区域 -->
      <div class="info-section">
        <img src="@/assets/images/loginPage/viewMyRoleText.png" alt="如何查看我的角色ID" class="info-title" />
        <div class="info-box">
          <div class="info-text">
            <p>登录游戏，进入大厅后，点击左侧上方角色头像，进入到【俱乐部】界面，昵称与头像下方的可复制的【唯一识别码】便是您的角色UID</p>
            <div class="imgView">
              <img class="viewImgShow" src="@/assets/images/loginPage/viewImg.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <!-- 底部箭头 -->
      <div class="bottom-arrows">
        <div class="arrow-down">›</div>
        <div class="arrow-down">›</div>
      </div>
    </div>

    <!-- 右侧装饰箭头 -->
    <div class="right-arrows">
      <img src="@/assets/images/loginPage/upArrow.png" alt="箭头" class="arrow-img" />
    </div>

  </div>
</template>

<script>
import CommonOverlay from '@/components/CommonOverlay/index.vue'
// layout 已改为由 App 根节点通过 class + CSS 控制，不再需要每页绑定
import { fetchDetailData } from '@/api/detail'
import { getPlayerAllInfos,getPlayerNames,getCode,toLoginByCode } from "@/api"
import { saveDetailCache } from '@/utils/detailCache'
import { saveTeamId } from '@/utils/userCache'
import { checkChannelType } from '@/utils/channelType'

export default {
  name: 'loginPage',
  components: { CommonOverlay },
  data() {
    return {
      uid: '',
      code: '',
      countdown: 0,
      countdownTimer: null,
      allPlayerInfo: {},
      allPlayerNames: {},
      channelType: '', // 渠道，包括官网和混服
    }
  },
  computed: {},
  mounted() {
    // 放开限制：允许用户随时访问 login 页。
    // 如果仍希望"有缓存自动跳详情"，建议改为在 indexPage 点击进入时判断，而不是 login 页 mounted 强制跳转。
    this.toGetPlayerAllInfo()

    // 完全参考detailPage的adjustSwiperHeight方法
    this.adjustPageHeight()
    window.addEventListener('resize', this.adjustPageHeight)
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer)
    window.removeEventListener('resize', this.adjustPageHeight)
  },
  methods: {
    handleSendCode() {
      if (this.countdown > 0) return
      if (!this.uid.trim()) {
        this.$toast.show('请先输入游戏UID')
        return
      }

      // TODO: 这里后续接真实接口：发送验证码到游戏内邮箱
      // 先做倒计时锁定
      this.countdown = 120
      if (this.countdownTimer) clearInterval(this.countdownTimer)
      this.countdownTimer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
          this.countdown = 0
        }
      }, 1000)
      let param = {
        teamId: this.uid
      }
      this.channelType = checkChannelType(param.teamId)
      getCode(param,this.channelType).then(resRef => {
        let res = resRef.data
        if (res.code === 0){
          this.$toast.show('验证码发送成功，请前往游戏内邮箱查看')
        }else {
          this.$toast.show('验证码发送失败，稍后重试')
        }
      })
    },
    handleLogin() {
      if (!this.uid.trim()) {
        this.$toast.show('请先输入游戏UID')
        return
      }
      if (!this.code.trim()) {
        this.$toast.show('请输入验证码')
        return
      }
      let param = {
        teamId: this.uid,
        code: this.code
      }
      this.channelType = checkChannelType(param.teamId)
      // 登录后预拉取详情数据，减少详情页等待时间
      toLoginByCode(param,this.channelType).then(resRef => {
        let res = resRef.data
        if (res.code === 0){
          let detailParam = {
            teamId: this.uid,
            askType: '1',
            askTeamId: '1'
          }
          fetchDetailData(detailParam,this.channelType).then((res) => {
            let result = res.data
            if (result.code === 0){
              let dataInit = result.data
              if (!dataInit.reviewData) {
                dataInit.reviewData = {}
              }
              if (dataInit.reviewData && dataInit.reviewData.maxAgentPlayer){
                dataInit.maxAgentPlayerIds = dataInit.reviewData.maxAgentPlayer.split(',')
              }
              const payload = this.dataAssembly(dataInit)
              this.$store.commit('SET_DETAIL_DATA', payload)
              saveDetailCache(payload)
              // 将昵称写入本地缓存（目前接口无昵称字段，先用 UID 占位；若后续接口提供 nickName，可替换）
              let teamIdAndNick = {
                teamId: dataInit.teamId,
                nickName: dataInit.teamName
              }
              saveTeamId(JSON.stringify(teamIdAndNick))
              this.$router.push('/detail')
            }
          }).catch(() => {
            this.$toast.show('获取详情数据失败，请稍后重试')
          })
        }else {
          this.$toast.show('uid或验证码填写错误！')
        }
      })

    },
    // 拉所有球员
    toGetPlayerAllInfo() {
      getPlayerAllInfos().then(res => {
        if (res.status === 200) {
          this.handleForIdKey(res.data).then(() => {
            this.toGetPlayerNames()
          }).catch(err => {
            console.log(err);
          })

        }else {
          console.log('出错啦');
        }
      })
    },
    handleForIdKey(data) {
      return new Promise((resolve, reject) => {
        if (data.length > 0) {
          data.map(val => {
            if (val.player_id) {
              this.allPlayerInfo[val.player_id] = val;
            } else {
              console.error('Missing player_id in:', val);
            }
          });
          resolve(); // 解决Promise
        } else {
          reject('No data provided'); // 拒绝Promise
        }
      });
    },
    toGetPlayerNames() {
      getPlayerNames().then(res => {
        if (res.status === 200) {
          this.allPlayerNames = res.data
        }else {
          console.log('出错了');
        }
      })
    },
    dataAssembly(data){
      let dataInit = data
      dataInit.goalKingIdName = this.setDefault(dataInit,'goalKingIdDaily')
      dataInit.reviewData.maxScorePlayerIdAgentName = this.setDefault(dataInit,'maxScorePlayerIdAgent',2)
      if (dataInit.reviewData.maxAgentPlayer){
        dataInit.maxAgentPlayerNames = this.setGoodPlayerNames(dataInit,'maxAgentPlayerIds')
      }else {
        dataInit.maxAgentPlayerNames = []
      }
      return dataInit;
    },
    setGoodPlayerNames(row,key){
      if (!row[key]?.length) return [];

      const { allPlayerInfo, allPlayerNames } = this;

      return row[key].map(val => {
        const playerInfo = allPlayerInfo[val];
        if (!playerInfo) return val;

        const playerName = playerInfo.player_name;
        return allPlayerNames[playerName]?.CN || allPlayerNames[playerName]?.EN || val;
      });
    },
    setDefault(row, key1, level) {
      // 初始化默认返回值
      let handled = '';
      const levelData = (level === 2 && row.reviewData && Object.keys(row.reviewData).length > 0)
          ? row.reviewData
          : row;
      // 如果 key1 不存在于 levelData 中，直接返回默认值
      if (!levelData[key1]) return handled;
      // 获取玩家信息
      const playerInfo = this.allPlayerInfo[levelData[key1]];
      if (!playerInfo) return handled;
      // 获取玩家名称
      const playerName = this.allPlayerInfo[levelData[key1]]?.player_name;
      if (!playerName) return handled;
      // 获取玩家名称的中文翻译
      return this.allPlayerNames[playerName]?.CN || handled;
    },
    // 完全参考detailPage的adjustSwiperHeight方法
    adjustPageHeight() {
      // - use-design-size：固定 1334（配合全局缩放）
      // - use-fluid-size：使用真实视口高度，避免出现底部黑边留白
      if (this.$el) {
        const root = document.querySelector('.app-scale-root')
        const isFluid = root && root.classList.contains('use-fluid-size')

        if (isFluid) {
          // 使用视觉视口高度（iOS Safari 地址栏变化时更准确）
          const vv = window.visualViewport
          const h = (vv && vv.height) ? vv.height : window.innerHeight
          this.$el.style.height = `${h}px`
        } else {
          this.$el.style.height = `1334px`
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.loginPage {
  /* 同 indexPage：缩放画布模式下使用 100% 继承 1334 画布高度 */
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  /* 设计稿模式下保持内容为 750 宽（配合外层缩放），避免被拉伸到 100% */
  max-width: 750px;
  margin: 0 auto;

  // 第一层：bgImg 底层背景
  background-image: url('@/assets/images/loginPage/bgImg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  // 第二层：bottomLine 和 topLine
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        url('@/assets/images/loginPage/topLine.png'),
        url('@/assets/images/loginPage/bottomLine.png');
    background-size:
        100% auto,
        100% auto;
    background-position:
        top center,
        bottom center;
    background-repeat: no-repeat, no-repeat;
    pointer-events: none;
    z-index: 1;
  }
}

.right-arrows {
  position: absolute;
  right: 10px;
  bottom: 35%;
  z-index: 10;

  .arrow-img {
    width: 0.48rem;
    height: auto;
    display: block;
  }
}

@media (max-width: 750px) {
  .loginPage {
    max-width: none;
    margin: 0;
  }
}

// 主要内容区域
.main-content {
  position: absolute;
  top: 2.5rem;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  z-index: 10;
}

/* 设计稿缩放模式下：按 1334 高度布局，不裁切验证码区域 */
.use-design-size :deep(.loginPage) .main-content {
  top: 3.1rem;
  bottom: auto;
  height: 1334px;
}

.big-title {
  margin-top: .6rem;
  margin-bottom: .8rem;
  font-size: 1rem;
  font-weight: 800;
  color: #333;
  letter-spacing: .08rem;
  //font-family: 'FontMedium', sans-serif;
}

.uid-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: .35rem;
}

.uid-input {
  width: 7rem;
  height: 0.76rem;
  font-size: 0.4rem;
  border: none;
  background-image: url('@/assets/images/loginPage/inputBg.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  color: #FFE4A7;
  text-align: center;
  padding: 0 .2rem;
  font-family: 'FontLight', sans-serif;
  &::placeholder {
    color: #FFE4A7;
  }

  &:focus {
    outline: none;
  }
}

.code-row {
  width: 7rem;
  min-height: .76rem;
  height: auto;
  display: flex;
  align-items: stretch;
  border: 2px dashed rgba(139, 116, 251, 0.5);
  border-radius: .12rem;
  background: rgba(255, 255, 255, 0.35);
  margin-bottom: .6rem;
  overflow: visible;
  font-family: 'FontLight', sans-serif;
  position: relative;
  /* 防止键盘弹起时被压缩 */
  flex-shrink: 0;
}

.code-input {
  /* 确保输入框有足够的最小宽度，防止被按钮挤压 */
  flex: 1 1 3rem;
  min-width: 3rem;
  width: auto;
  height: .76rem;
  min-height: .76rem;
  border: none;
  background: transparent;
  font-size: 0.38rem;
  padding: 0 .25rem;
  /* 为按钮预留空间 */
  padding-right: 3.5rem;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(0, 0, 0, 0.35);
  }

  &:focus {
    outline: none;
  }
}

.send-code-btn {
  position: absolute;
  right: .1rem;
  top: 50%;
  transform: translateY(-50%);
  /* 固定宽度，防止文案换行或被截断 */
  width: 3.2rem;
  max-width: 3.2rem;
  height: .56rem;
  background: transparent;
  color: #8B74FB;
  font-size: 0.25rem;
  padding: 0 .08rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px dashed rgba(139, 116, 251, 0.35);
  border-radius: .04rem;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 防止按钮被压缩 */
  flex-shrink: 0;

  &:disabled {
    color: rgba(139, 116, 251, 0.5);
    cursor: not-allowed;
  }
}

/*
  高度不足 1334（例如 768x1024）时：
  不改变缩放策略的情况下，通过减少间距把登录页内容尽量压缩到一屏内。
  （详情页仍然依赖整体缩放来保证一屏展示）
*/
@media (max-height: 1334px) {
  .main-content {
    top: 2.4rem;
    padding: 12px;
  }

  .big-title {
    margin-top: .35rem;
    margin-bottom: .45rem;
    font-size: .9rem;
  }

  .code-row {
    margin-bottom: .4rem;
  }

  .login-btn {
    margin-bottom: .6rem;
  }

  .info-section {
    width: 92%;

    .info-box {
      height: 3.2rem;
      padding: 10px;
    }
  }

  .game-btn {
    margin-top: .3rem;
  }
}

// 登录按钮（保持视觉接近设计稿截图）
.login-btn {
  width: 7.1rem;
  height: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.5rem;
  font-weight: 800;
  color: #111;
  background: linear-gradient(180deg, #BFA8FF 0%, #8B74FB 100%);
  border-radius: .12rem;
  cursor: pointer;
  user-select: none;
  margin-bottom: 1rem;

  &:active {
    transform: scale(0.98);
  }
}


// 说明文本区域
.info-section {
  width: 90%;

  .info-title {
    width: 4.05rem;
    height: 0.45rem;
    margin: 0 auto 10px;
    display: block;
  }

  .info-box {
    width: 7.3rem;
    height: auto;
    background-image: url('@/assets/images/loginPage/viewRoleBg.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    padding: 15px;
    overflow-y: auto;
    margin: 0 auto;

    .info-text {
      font-size: 0.3rem;
      color: #FFE4A7;
      line-height: 1.6;
      margin: 0;
      text-align: left;
      font-family: 'FontLight', sans-serif;
    }
    .imgView{
      .viewImgShow{
        width: 100%;
        height: auto;
      }
    }
  }
}

// 进入游戏按钮
.game-btn {
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: .52rem;

  .game-btn-img {
    width: 3.35rem;
    height: 0.87rem;
    display: block;
  }

  &:active {
    transform: scale(0.98);
  }
}

// 底部箭头
.bottom-arrows {
  display: flex;
  gap: 10px;
  margin-top: 10px;

  .arrow-down {
    color: rgba(0, 0, 0, 0.3);
    font-size: 24px;
    transform: rotate(90deg);
    animation: arrowBounce 1.5s ease-in-out infinite;
  }
}

@keyframes arrowBounce {
  0%, 100% {
    transform: rotate(90deg) translateY(0);
  }
  50% {
    transform: rotate(90deg) translateY(5px);
  }
}


// 第三层：bgCover 覆盖整个背景
.loginPage::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('@/assets/images/loginPage/bgCover.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  pointer-events: none;
  z-index: 2;
}

// 第四层：bottomBg1 放在背景最上层，居于底部
.bottom-bg-layer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 50%;
  background-image: url('@/assets/images/loginPage/bottomBg1.png');
  background-size: 100% auto;
  background-position: bottom center;
  background-repeat: no-repeat;
  pointer-events: none;
  z-index: 3;
}

/* 移动端键盘适配 - 防止输入框被键盘压缩 */
@media screen and (max-width: 768px) {
  .loginPage {
    /* 当键盘弹起时，确保容器高度稳定 */
    min-height: 100vh;
  }

  .main-content {
    /* 确保输入区域在键盘弹起时不会被过度压缩 */
    min-height: auto;
    overflow: visible;
  }

  .code-row {
    /* 强制保持最小高度，防止被键盘压缩成一条线 */
    min-height: .76rem !important;
    height: .76rem !important;
    flex-shrink: 0 !important;
  }

  .code-input {
    /* 确保输入框在任何情况下都保持可见的最小高度 */
    min-height: .76rem !important;
    height: .76rem !important;
    flex-shrink: 0 !important;
  }

  .send-code-btn {
    /* 确保按钮不会被压缩或变形 */
    min-height: .56rem !important;
    height: .56rem !important;
    flex-shrink: 0 !important;
  }

  /* 当视口高度小于500px时（通常是键盘弹起的情况） */
  @media (max-height: 500px) {
    .main-content {
      /* 减少上方间距，为输入框预留更多空间 */
      top: 1.5rem;
      padding: 10px;
    }

    .big-title {
      margin-top: .2rem;
      margin-bottom: .3rem;
      font-size: .8rem;
    }

    .uid-wrapper {
      margin-bottom: .2rem;
    }

    .code-row {
      margin-bottom: .3rem;
      /* 在键盘弹起时确保验证码区域始终可见 */
      position: relative;
      z-index: 999;
    }

    .login-btn {
      margin-bottom: .3rem;
    }

    /* 键盘弹起时隐藏说明文本区域，为输入区域腾出空间 */
    .info-section {
      display: none;
    }

    .bottom-arrows {
      display: none;
    }
  }
}
</style>
